import { mapState } from 'vuex';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import flatMap from 'lodash/flatMap';
import values from 'lodash/values';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { themesMixin } from '../../../utils/themes';
export default {
  name: 'NiotaClassicApplicationsCsvExport',
  mixins: [themesMixin],
  props: {
    applicationId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function () {
    const start = new Date(new Date() - 86400000 * 2);
    const end = new Date();
    return {
      start,
      end,
      exportQuery: {
        applicationId: this.applicationId,
        time: {
          from: start,
          to: end
        },
        outputType: 'one-file-per-device-variable'
      },
      exportVariables: [],
      variables: [],
      variablesIsUpdating: true,
      formValid: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    backgroundColor() {
      return `background-color: ${this.vuetifyColorHex('info')}`;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    }
  },
  watch: {},
  created() {
    this.fetchVariables();
  },
  methods: {
    datePicked(dateObject) {
      this.start = new Date(dateObject.from * 1000);
      this.end = new Date(dateObject.to * 1000);
      this.exportQuery = {
        ...this.exportQuery,
        time: {
          from: this.start,
          to: this.end
        }
      };
    },
    variablesChanged() {
      this.exportQuery = {
        ...this.exportQuery,
        variables: this.exportVariables
      };
      this.formValid = !!this.exportVariables.length;
    },
    async fetchVariables() {
      this.variablesIsUpdating = true;
      const devices = await NiotaClassicApiService.getApplicationDevicesPlain(this.applicationId).then(res => {
        return res.data.devices;
      }).catch(error => {
        console.error({
          error
        });
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorLoadingParsedPackets'), 'error');
      });
      const variables = flatMap(devices, device => {
        let parserVariables = [];
        if (get(device, 'deviceType.parser.type') === 'multi') {
          parserVariables = flatMap(get(device, 'deviceType.parser.config'), (config, name) => {
            return values(name === '__switch' ? {} : get(config, 'variables', {}));
          });
        } else {
          parserVariables = get(device, 'deviceType.parser.config.variables');
        }
        if (!parserVariables) {
          return [];
        }
        return flatMap(parserVariables, parserVariable => {
          const measurement = get(parserVariable, 'value_type.base_unit');
          const name = parserVariable.name;
          if (!measurement) {
            return [];
          }
          return {
            label: `${name} (${measurement})`,
            variable: name,
            measurement
          };
        });
      });
      this.variables = sortBy(uniqBy(variables, 'label'), 'label');
      this.variablesIsUpdating = false;
    }
  }
};